import {miniSerializeError} from '@reduxjs/toolkit';
import {match, Pattern} from 'ts-pattern';

import type {ApiError} from 'shared/web';

/** Preserve validated query failures and serialize other rejected values before host handling. */
export function normalizeBulkOperationError(error: unknown): ApiError {
  return match(error)
    .with({status: Pattern.number, data: Pattern.any}, ({status, data}) => ({status, data}))
    .with(
      {status: Pattern.union('FETCH_ERROR', 'TIMEOUT_ERROR'), error: Pattern.string},
      (value) => value
    )
    .with(
      {
        status: 'PARSING_ERROR',
        originalStatus: Pattern.number,
        data: Pattern.string,
        error: Pattern.string,
      },
      (value) => value
    )
    .with({status: 'CUSTOM_ERROR', error: Pattern.string}, (value) => value)
    .otherwise(miniSerializeError);
}
